// 시간을 00:00:00.000 형식으로 포맷하는 함수 (밀리초 포함)
export const formatTime = (milliseconds) => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  const ms = Math.floor((milliseconds % 1000) / 10); // 10ms 단위로 표시
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(2, '0')}`;
};

// 00:00:00.00 형태의 문자열을 밀리초로 변환하는 공통 함수
export const parseTime = (timeStr) => {
  if (!timeStr) return 0;
  const parts = timeStr.split(':');
  const seconds = parts[2] ? parseFloat(parts[2]) : 0;
  const minutes = parseInt(parts[1]) || 0;
  const hours = parseInt(parts[0]) || 0;
  return (hours * 3600 + minutes * 60 + seconds) * 1000;
};

// createdAt 필드를 밀리초로 변환하는 공통 함수
export const parseCreatedAt = (createdAt) => {
  if (!createdAt) return 0;
  if (typeof createdAt === 'string') {
    return new Date(createdAt).getTime();
  }
  if (createdAt?.toMillis) {
    return createdAt.toMillis();
  }
  if (createdAt?.seconds) {
    return createdAt.seconds * 1000 + (createdAt.nanoseconds || 0) / 1000000;
  }
  return 0;
};